import React, { useState, useCallback } from "react";
import MembershipSidebar from "./components/MembershipSidebar";
import MembershipEditor from "./components/MembershipEditor";
import { useMemberships } from "./hooks/useMemberships";
import { membershipDefaults } from "../../../models/membership";
import { ConfirmDialog, MasterDetailLayout, Breadcrumb } from "../../../components/Common";

/**
 * Memberships Page (Módulo de Memberships/Planos)
 * Layout Master-Detail: Listagem lateral com drag & drop e editor.
 */
const MembershipsPage = () => {
    const { memberships, loading, isSaving, actions } = useMemberships();
    const [selectedMembership, setSelectedMembership] = useState(membershipDefaults);
    const [isDirty, setIsDirty] = useState(false);

    const handleSelectMembership = useCallback(async (membership) => {
        if (selectedMembership?.id === membership.id) return;

        const isActuallyDirty = isDirty && (selectedMembership?.id || selectedMembership?.name?.trim() !== "" || false);

        if (isActuallyDirty) {
            const confirmed = await ConfirmDialog({
                title: "Alterações não salvas",
                text: "Você tem alterações pendentes nesta membership. Deseja descartá-las?",
                confirmButtonText: "Sim, descartar",
                cancelButtonText: "Cancelar"
            });
            if (!confirmed) return;
        }

        setSelectedMembership(membership);
        setIsDirty(false);
    }, [selectedMembership, isDirty]);

    const handleCreateNew = useCallback(async () => {
        const isActuallyDirty = isDirty && (selectedMembership?.id || selectedMembership?.name?.trim() !== "" || false);

        if (isActuallyDirty) {
            const confirmed = await ConfirmDialog({
                title: "Alterações não salvas",
                text: "Deseja descartar as mudanças atuais e criar uma nova membership?",
                confirmButtonText: "Sim, descartar",
                cancelButtonText: "Cancelar"
            });
            if (!confirmed) return;
        }
        setSelectedMembership(membershipDefaults);
        setIsDirty(false);
    }, [isDirty, selectedMembership]);

    const handleSave = useCallback(async (data) => {
        const success = await actions.saveMembership(data);
        if (success) {
            setIsDirty(false);
        }
    }, [actions]);

    const handleDelete = useCallback(async (id) => {
        const success = await actions.deleteMembership(id);
        if (success) {
            setSelectedMembership(membershipDefaults);
            setIsDirty(false);
        }
    }, [actions]);

    const handleMarkDirty = useCallback((dirty) => setIsDirty(dirty), []);

    // PageLoader logic removido para carregamento nativo do sidebar/detalhe

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Contratos & Planos" />
            </div>

            <div className="border-top mb-3"></div>

            <div className="memberships-container mt-3">
                <MasterDetailLayout
                master={
                    <MembershipSidebar
                        memberships={memberships}
                        activeId={selectedMembership?.id}
                        onSelect={handleSelectMembership}
                        onCreateNew={handleCreateNew}
                        loading={loading}
                    />
                }
                detail={
                    <MembershipEditor
                        membership={selectedMembership}
                        onSave={handleSave}
                        onDelete={handleDelete}
                        isSaving={isSaving}
                        onChange={handleMarkDirty}
                    />
                }
            />
            </div>
        </React.Fragment>
    );
};

export default MembershipsPage;
